'use client';

import { UsedInPages } from '@/components/UsedInPages/UsedInPages';
import { Gutter, SetDocumentStepNav, useConfig, useDocumentInfo } from '@payloadcms/ui';

import type { DocumentDataWithUsedInPages } from '@/collections/modules/_shared/populate-used-in-pages';

import '@/components/UsedInPages/styles.scss';
import './UsedInPagesView.scss';

const BASE_CLASS = 'used-in-pages-view';
const VIEW_LABEL = 'Used in Pages';

export const UsedInPagesView = () => {
  const { id, collectionSlug, globalSlug, data, isTrashed } = useDocumentInfo();
  const { getEntityConfig } = useConfig();
  const collectionConfig = collectionSlug ? getEntityConfig({ collectionSlug }) : null;
  const globalConfig = globalSlug ? getEntityConfig({ globalSlug }) : null;
  const documentData = data as DocumentDataWithUsedInPages | undefined;
  const pages = documentData?.usedInPages ?? [];

  if (!pages.length) {
    return (
      <>
        <SetDocumentStepNav
          collectionSlug={collectionSlug}
          globalLabel={globalConfig?.label}
          globalSlug={globalSlug}
          id={id}
          isTrashed={isTrashed}
          pluralLabel={collectionConfig?.labels?.plural}
          useAsTitle={collectionConfig?.admin?.useAsTitle}
          view={VIEW_LABEL}
        />
        <Gutter className={`${BASE_CLASS}__wrap`}>
          <div className="fv-used-in-pages fv-used-in-pages--empty">
            <span className="fv-used-in-pages__label">This document is not used in any pages.</span>
          </div>
        </Gutter>
      </>
    );
  }

  return (
    <>
      <SetDocumentStepNav
        collectionSlug={collectionSlug}
        globalLabel={globalConfig?.label}
        globalSlug={globalSlug}
        id={id}
        isTrashed={isTrashed}
        pluralLabel={collectionConfig?.labels?.plural}
        useAsTitle={collectionConfig?.admin?.useAsTitle}
        view={VIEW_LABEL}
      />
      <Gutter className={`${BASE_CLASS}__wrap`}>
        <UsedInPages />
      </Gutter>
    </>
  );
};
